// src/pages/AddSecurity.js
import React, { useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import { collection, addDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const AddSecurity = () => {
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    location: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.code || !formData.location) {
      alert('Please fill in all fields');
      return;
    }

    try {
      setLoading(true);
      await addDoc(collection(db, 'security_officers'), {
        ...formData,
        createdAt: new Date(),
      });
      alert('Security Officer Registered Successfully');
      setFormData({ name: '', code: '', location: '' });
      navigate('/admin-dashboard');
    } catch (error) {
      console.error('Error adding security officer:', error);
      alert('Failed to register officer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '500px', margin: '0 auto' }}>
      <h2>Add Security Officer</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '1rem' }}>
          <label>Name:</label>
          <input
            type="text"
            name="name"
            placeholder="Officer Name"
            value={formData.name}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label>Unique Code:</label>
          <input
            type="text"
            name="code"
            placeholder="Unique Code"
            value={formData.code}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label>Assigned Location:</label>
          <input
            type="text"
            name="location"
            placeholder="Assigned Station/Location"
            value={formData.location}
            onChange={handleChange}
            required
            style={inputStyle}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: '#1B3B6F',
            color: 'white',
            padding: '0.6rem 1.5rem',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          {loading ? 'Registering...' : 'Register Officer'}
        </button>
      </form>
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '0.5rem',
  marginTop: '0.3rem',
  border: '1px solid #ccc',
  borderRadius: '5px'
};

export default AddSecurity;
